module.exports = __webpack_public_path__ + "media/icons/fullscreen-05af3a49.svg";